<template>
  <div id="app-footer-container">
    <v-footer v-if="isFooterVisible" app inset max-height="36px">
      <v-layout justify-center>
        <div>
          <v-btn v-if="currentAdvertisement > 0" icon small class="mr-2" @click="currentAdvertisement--">
            <v-icon small>fa-chevron-left</v-icon>
          </v-btn>
        </div>
        <span @click="showContentOnClick(advertisements[currentAdvertisement])" v-html="advertisements[currentAdvertisement].TITLE"
          :class="[isMobileOnly ? 'app-footer-mobile-content' : 'app-footer-content', advertisements[currentAdvertisement].HAVECONTENT ? 'app-fiiter-itemwithcontent' : '']"></span>
        <div>
          <v-btn v-if="currentAdvertisement < advertisements.length - 1" icon small class="ml-2" @click="currentAdvertisement++">
            <v-icon small>fa-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-layout>
    </v-footer>

    <v-dialog v-model="contentDlgShown" :fullscreen="$vuetify.breakpoint.xsOnly" :width="1024" @input="hideContentDlg" persistent
      @keydown.stop.esc="hideContentDlg" :content-class="'app-dialog advertisement-dialog ' + (isMobileOnly ? 'mobile' : '')">
      <v-card class="overflow-y-hidden d-flex flex-column">
        <v-form ref="addAdvForm" @submit.prevent="setReaded" class="d-flex flex-column overflow-y-hidden">

          <v-toolbar class="app-dialog-header">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon small @click="hideContentDlg">
              <v-icon small>fa-times</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="app-dialog-body flex-grow-1 overflow-y-hidden d-flex pr-2">
            <div class="overflow-y-hidden w-100">
              <dx-scroll-view direction="both">
                <div v-html="content" class="advertisement-content-container" :class="isMobileOnly ? 'mobile' : ''"></div>
              </dx-scroll-view>
            </div>
          </v-card-text>

          <v-card-actions class="app-dialog-footer">
            <v-spacer></v-spacer>
            <v-btn v-if="showReadedButton" type="submit" color="primary">{{ $t('buttons.readed') }}</v-btn>
            <v-btn color="secondary" @click="hideContentDlg"> {{ $t('buttons.close') }}</v-btn>
          </v-card-actions>

        </v-form>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import AppTooltip from '@/components/Common/AppTooltip';
import { actions as _act } from '@/models/store.actions';

import { advertisementsService } from '@/services/advertisements.service';
import { AppError } from '@/models/log.models';
import { logHelper } from '@/helpers';
import { DxScrollView } from 'devextreme-vue/scroll-view';

export default {
  name: 'AppFooter',
  components: { AppTooltip, DxScrollView },
  inject: ['isMobileOnly'],
  data: function() {
    return {
      advertisements: null,
      currentAdvertisement: 0,
      advertisementCount: 0,
      contentDlgShown: false,
      showReadedButton: false,
      advertisementId: null,
      content: '',
      title: '',
      advCountersMutationUnsubscribe: null
    };
  },
  created() {
    this.subscribe();
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    if (this.isLogined) {
      this.loadAdv();
    }
  },
  computed: {
    isLogined() {
      return this.$store.getters[_act.AUTH_GET_ISLOGINEDGET];
    },
    isFooterVisible() {
      return !!this.advertisements && !!this.advertisements.length;
    }
  },
  methods: {
    setReaded() {
      if (this.advertisementId) {
        advertisementsService
          .ReadConfirm(this.advertisementId)
          .then(() => {
            this.hideContentDlg();
          })
          .catch(this.errorHandler);
      }
    },
    loadUnread() {
      advertisementsService
        .UnreadGet()
        .then((advertisements) => {
          this.advertisements = advertisements.data;
          this.advertisementCount = this.advertisements.length;
          let unread = this.advertisements.filter(
            (d) =>
              d.SHOWUSERALERT === 1 && d.ADVERTISEMENTCONFIRMEDUSER_ID === null
          );
          if (unread && unread.length > 0) {
            this.showContent(unread[0]);
          }
        })
        .catch(this.errorHandler);
    },
    loadAdv() {
      advertisementsService
        .Get()
        .then((advertisements) => {
          this.advertisements = advertisements.data;
          this.advertisementCount = this.advertisements.length;
        })
        .catch(this.errorHandler);
    },
    hideContentDlg() {
      this.contentDlgShown = false;
      this.content = '';
    },
    showContent(item) {
      if (item.HAVECONTENT) {
        this.title = item.TITLE;
        advertisementsService
          .ContentGet(item.ADVERTISEMENT_ID)
          .then((data) => {
            if (data && data.data && data.data.length > 0) {
              this.content = data.data[0].CONTENT;
              if (
                item.SHOWUSERALERT &&
                item.SHOWUSERALERT === 1 &&
                item.ADVERTISEMENTCONFIRMEDUSER_ID === null &&
                this.isLogined
              ) {
                this.showReadedButton = true;
                this.advertisementId = item.ADVERTISEMENT_ID;
              } else {
                this.showReadedButton = false;
                this.advertisementId = null;
              }
              this.contentDlgShown = true;
            }
          })
          .catch(this.errorHandler);
      }
    },
    showContentOnClick(item) {
      if (this.isLogined) {
        this.showContent(item);
      }
    },
    userLoggedMessageHandler() {
      this.loadAdv();
    },
    userLoggedOutMessageHandler() {
      this.advertisements = null;
      this.advertisementCount = 0;
      this.currentAdvertisement = 0;
      this.advertisementId = null;
    },
    onDocumentsCountersChanged(state) {
      if (
        state &&
        state.documents &&
        state.documents.counters &&
        state.documents.counters.advertisementCount &&
        (this.advertisementCount !==
          state.documents.counters.advertisementCount ||
          state.documents.counters.notConfirmedAdvertisementCount > 0)
      ) {
        this.loadUnread();
      }
    },
    subscribe() {
      this.advCountersMutationUnsubscribe = this.$store.subscribe(
        (mutation, state) => {
          if (mutation.type === _act.DOC_MUT_ADDCOUNTERS) {
            this.onDocumentsCountersChanged(state);
          }
        }
      );
      this.$eventBus.$on('user-logged', this.userLoggedMessageHandler);
      this.$eventBus.$on('user-logged-out', this.userLoggedOutMessageHandler);
    },
    unsubscribe() {
      this.$eventBus.$off('user-logged', this.userLoggedMessageHandler);
      this.$eventBus.$off('user-logged-out', this.userLoggedOutMessageHandler);
      this.advCountersMutationUnsubscribe();
    },
    errorHandler(error) {
      if (!(error instanceof AppError)) {
        logHelper.error(error);
      }
    }
  },
  watch: {
    advertisements() {
      this.$eventBus.$emit('footer-visibility-changed', {
        isFooterVisible: this.isFooterVisible
      });
    }
  }
};
</script>

<style lang="scss">
.app-footer-content {
  white-space: nowrap;
  overflow: hidden;
}

.app-fiiter-itemwithcontent {
  cursor: pointer;
}

.app-footer-mobile-content {
  max-width: 75vw;
  white-space: normal;
  overflow: hidden;
  overflow-wrap: break-word;

  &.mobile {
    max-width: 100vw;
  }
}

.advertisement-dialog {
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}
.advertisement-content-container {
  &.mobile {
    img {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
